import { FunctionComponent, SVGProps } from 'react';

import { ESpotTextureStyle } from './ESpotsSlide.types';
import { ReactComponent as BallLeftDesktopTexture } from './textures/ball-left-texture.svg';
import { ReactComponent as BallRightDesktopTexture } from './textures/ball-right-texture.svg';
import { ReactComponent as GripDesktopTexture } from './textures/grip-texture.svg';

const TEXTURES: Record<string, FunctionComponent<SVGProps<SVGSVGElement>>> = {
    grip: GripDesktopTexture,
    'ball left': BallLeftDesktopTexture,
    'ball right': BallRightDesktopTexture,
};

export const getESpotTexture = (
    textureStyle: ESpotTextureStyle | undefined,
): JSX.Element | null => {
    if (!textureStyle) {
        return null;
    }

    const TextureComponent = TEXTURES[textureStyle];

    if (!TextureComponent) {
        return null;
    }

    return <TextureComponent data-testid={textureStyle} />;
};
